import React, { useState, useEffect } from "react";
import { Constants } from "../../constants/appConstants";
import { Order } from "../../models/csos/order";
import { useOrderDetailsService } from "../../services/component/orderDetailsService";
import { fetchAndProcessOrder } from "../../utils/fetchAndProcessOrder";
import { formatCurrency } from "../../utils/formatCurrency";
import ModalContent from "../modalContent/ModalContent";
import OrderDetailHeader from "./OrderDetailHeader";
import OrderDetailFooter from "./OrderDetailFooter";
import UpdateQuantityComponent from "./updateQuantity/UpdateQuantity";
import TimeOut from "./timeOut/TimeOut";
import "./OrderDetail.css";

const OrderDetailComponent: React.FC = () => {
  const orderDetailsService = useOrderDetailsService();
  const [order, setOrder] = useState<any>({});
  const [orderLockedTime, setOrderLockedTime] = useState<any>(null);
  const [showOrderDetailModal, setShowOrderDetailModal] = useState(false);

  useEffect(() => {
    const unsub1 = orderDetailsService.orderAnnounced$.subscribe((announcedOrder: Order) => {
      populate(announcedOrder.orderId, announcedOrder.account);
      setOrderLockedTime(announcedOrder.lockOrderTime);
    });
    const unsub2 = orderDetailsService.closeOrderDetail$.subscribe((close) => {
      if (close) {
        setShowOrderDetailModal(false);
        document.body.classList.remove("blockscroll");
      }
    });
    return () => { unsub1(); unsub2(); };
    // eslint-disable-next-line
  }, [orderDetailsService]);

  const populate = (id: string, account: string) => {
    fetchAndProcessOrder(id, account).then((o) => {
      if (o) {
        setOrder(o);
        setShowOrderDetailModal(true);
        document.body.classList.add("blockscroll");
        orderDetailsService.announcestartTimer(o);
      } else {
        orderDetailsService.resetTimer("reset");
        refreshOrderSummary();
      }
    }).catch(() => {
      refreshOrderSummary();
    });
  };

  const refreshOrderSummary = () => {
    orderDetailsService.refreshorder("refresh");
  };

  return (
    <>
      <ModalContent visible={showOrderDetailModal}>
        <div className="order-detail-modal">
          <div className="modal-fade" role="dialog">
            <div className="modal-dialog modal-lg modal-sm modal-md">
              <div className="modal-content">
                <OrderDetailHeader order={order} orderlockedtime={orderLockedTime} />
                {order.status === Constants.FAILURE && (
                  <div className="failure-Message">
                    <span className="failure">Failure Message: {order.hostMessage}</span>
                  </div>
                )}
                <hr />
                <div className="modal-body" id="orderDetailsTableModalId">
                  <div className="table-container">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th><span className="text-nowrap" title="Order Sequence">SEQ</span></th>
                          <th><span className="text-nowrap" title="Original Ordered Quantity">ORIGINAL QTY</span></th>
                          <th><span className="text-nowrap" title="Order Quantity">ORDER QTY</span></th>
                          <th><span className="text-nowrap" title="Cardinal Identification Number">CIN</span></th>
                          <th><span className="text-nowrap" title="Total Number of Units on Order">TOTAL UNITS</span></th>
                          <th><span className="text-nowrap" title="Generic Code Number Average Monthly Usage">GCN AMU</span></th>
                          <th><span className="text-nowrap" title="Generic Code Number Last 30 days Ordered">GCN LAST 30 DAYS</span></th>
                          <th><span className="text-nowrap" title="Nation Drug Code">NDC</span></th>
                          <th><span className="text-nowrap" title="Trade Name for the given product">TRADE NAME</span></th>
                          <th><span className="text-nowrap" title="Contract">CONTRACT</span></th>
                          <th><span className="text-nowrap" title="Product Strength">STRENGTH</span></th>
                          <th><span className="text-nowrap" title="Product Form">FORM</span></th>
                          <th><span className="text-nowrap" title="Product Package Size">SIZE</span></th>
                          <th><span className="text-nowrap" title="Total Size">TOTAL SIZE</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        {order.orderLines && order.orderLines.map((orderLine: any, i: number) => (
                          <tr key={i}>
                            <td>{orderLine.sequence}</td>
                            <td>{orderLine.originalQuantity}</td>
                            <td>
                              <UpdateQuantityComponent
                                order={order}
                                orderq={orderLine.orderQuantity}
                                dataIndex={i}
                                itemId={orderLine.itemId}
                                sequence={orderLine.sequence}
                              />
                            </td>
                            <td>{orderLine.cin}</td>
                            <td>{orderLine.totalUnits}</td>
                            <td>{orderLine.gcnAmu}</td>
                            <td>{orderLine.gcnLast30Days}</td>
                            <td>{orderLine.ndc}</td>
                            <td>{orderLine.tradeName}</td>
                            <td>{orderLine.contract}</td>
                            <td>{orderLine.strength}</td>
                            <td>{orderLine.form}</td>
                            <td>{orderLine.size}</td>
                            <td>{orderLine.totalSize}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer">
                  <OrderDetailFooter order={order} setOrder={setOrder} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalContent>
      <TimeOut />
    </>
  );
};

export default OrderDetailComponent;
